<template>
  <ui-modal v-bind="$attrs" v-on="$listeners">
    <template #activator="scope">
      <slot name="activator" v-bind="scope" />
    </template>

    <template #title>
      Overdue payouts
    </template>

    <div
      v-for="item in payouts"
      :key="item.workplace.id"
      class="d-flex justify-content-between align-items-center mt-4"
    >
      <router-link
        :to="{ name: 'location-view', params: { locationId: item.workplace.id }}"
        class="card-label"
      >
        {{ item.workplace.name }}
      </router-link>
      <div class="card-value d-flex align-items-center">
        {{ item.totalAmountTips.amount | money(item.totalAmountTips.currency)}}
        <stats-overdue-info
          :days="item.overdueDays"
          :since="item.firstNoneTaxCalculationDate"
          class="ml-2"
        />
      </div>
    </div>
  </ui-modal>
</template>

<script>
import StatsOverdueInfo from '@/components/Stats/StatsOverdueInfo.vue';

export default {

  components: {
    StatsOverdueInfo,
  },

  props: {
    payouts: {
      type: Array,
      required: true,
    },
  },
};
</script>
